const blogID = process.env.blogID || "6441015830884957540" 
const apiKEY = process.env.apiKEY || "AIzaSyCiCVRA_piXmjC5erpBKXSEgCqLLcvD_yc"
const apiRequestURL = `https://www.googleapis.com/blogger/v3/blogs/${blogID}/posts?key=${apiKEY}`

export {apiRequestURL}